import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase/config";
import { ensureAdminProfile } from "../../firebase/helpers";
import Logo from "../images/logo.png";

function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [status, setStatus] = useState({ loading: true, error: "" });
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        await ensureAdminProfile(user);
        setLoggedIn(true);
      }
      setStatus({ loading: false, error: "" });
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.email || !form.password) {
      setStatus({ loading: false, error: "يرجى إدخال البريد وكلمة المرور." });
      return;
    }

    try {
      setStatus({ loading: true, error: "" });
      const credential = await signInWithEmailAndPassword(auth, form.email, form.password);
      await ensureAdminProfile(credential.user);
      navigate("/admin", { replace: true });
    } catch (error) {
      setStatus({
        loading: false,
        error: "فشل تسجيل الدخول. تحقق من البريد وكلمة المرور.",
      });
    }
  };

  if (loggedIn) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <main className="content-wrapper admin-auth-page">
      <section className="container py-5 my-lg-4">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-7">
            <div className="card border-0 shadow-sm rounded-5 overflow-hidden">
              <div className="card-body p-4 p-md-5" dir="rtl">
                <div className="text-center mb-4">
                  <img src={Logo} alt="Logo" style={{ width: 90, height: 90, objectFit: "contain" }} />
                  <h1 className="h3 mt-3 mb-2">تسجيل دخول الأدمن</h1>
                  <p className="text-body-secondary mb-0">
                    هذه الصفحة خاصة بإدارة المتجر فقط
                  </p>
                </div>

                {status.error ? <div className="alert alert-danger">{status.error}</div> : null}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">البريد الإلكتروني</label>
                    <input
                      type="email"
                      className="form-control form-control-lg rounded-pill"
                      value={form.email}
                      onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
                      placeholder="admin@example.com"
                    />
                  </div>

                  <div className="mb-4">
                    <label className="form-label">كلمة المرور</label>
                    <input
                      type="password"
                      className="form-control form-control-lg rounded-pill"
                      value={form.password}
                      onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))}
                      placeholder="********"
                    />
                  </div>

                  <button className="btn btn-dark btn-lg rounded-pill w-100" type="submit" disabled={status.loading}>
                    {status.loading ? "جارٍ التحقق..." : "دخول لوحة التحكم"}
                  </button>
                </form>

                <div className="text-center mt-4">
                  <Link to="/" className="nav-link animate-underline d-inline-flex">
                    <span className="animate-target">العودة إلى المتجر</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AdminLogin;